import React, { PropTypes } from 'react';
import Zoomer from 'common/components/zoomer';

const VoteRevision = ({ image, width, height, description, name }) => (
  <div>
    {image && 
      <Zoomer imageWidth={width} imageHeight={height}>
        <img src={image} alt={description} />
      </Zoomer>
    }
    {name && <div className="single-entry-name">{name}</div>}
  </div>
);

VoteRevision.propTypes = {
  image: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  description: PropTypes.string,
  name: PropTypes.string,
};

export default VoteRevision;



// WEBPACK FOOTER //
// ./focus_groups/components/vote_revision.jsx